// @flow

import { Global, css } from '@emotion/react'
import * as React from 'react'

export const PrintStyles = () => {
  return (
    <Global
      styles={css`
        @media print {
          body,
          html {
            height: 100%;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden;
          }
          * {
            background: transparent !important;
            color: #000 !important;
          }
          input {
            font-size: 15px !important;
          }
          .force-print {
            display: block !important;
          }
          div[class*='ComponentSection'] ~ *,
          div[class*='HeaderRoot'],
          div[class*='Wrapper'],
          div[class*='ContentWrapper'],
          .no-print,
          .gatsby-image-wrapper,
          button {
            display: none !important;
          }
        }
      `}
    />
  )
}
